/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { StockRulesEntrypointProps } from './StockRules.entrypoint.types.tsx';

type StockRulesEntryPointComponent = EntryPointComponent<{}, {}, StockRulesEntrypointProps, {}>;

export const stockRulesEntryPoint: EntryPoint<StockRulesEntryPointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForInteraction<StockRulesEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-hardware-stock-rules" */ './StockRules.tsx',
			{ moduleName: 'itam-ham-settings-stock-rules' },
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	},
);
